import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import AdminInbox from "@/pages/AdminInbox";
import PrintMenu from "@/pages/PrintMenu";
import { Therapists } from "@/components/spa/Therapists";
import { SoundToggle } from "@/components/spa/SoundToggle";
import { ArrivalGate } from "@/components/spa/ArrivalGate";
import { ScrollProgress } from "@/components/spa/ScrollProgress";
import { CustomCursor } from "@/components/spa/CustomCursor";
import { SignatureRituals } from "@/components/spa/SignatureRituals";
import { PromoSpotlight } from "@/components/spa/PromoSpotlight";
import { LanguageProvider } from "@/i18n/LanguageContext";
import { AmbienceProvider } from "@/context/AmbienceContext";
import { Navbar } from "@/components/spa/Navbar";
import { ArrivalJourney } from "@/components/spa/ArrivalJourney";
import { EditorialMarquee } from "@/components/spa/Marquee";
import { Philosophy } from "@/components/spa/Philosophy";
import { Experience } from "@/components/spa/Experience";
import { Services } from "@/components/spa/Services";
import { Offers } from "@/components/spa/Offers";
import { GiftCertificates } from "@/components/spa/GiftCertificates";
import { Atmosphere } from "@/components/spa/Atmosphere";
import { Testimonials } from "@/components/spa/Testimonials";
import { Faq } from "@/components/spa/Faq";
import { Booking } from "@/components/spa/Booking";
import { Contact } from "@/components/spa/Contact";
import { Footer } from "@/components/spa/Footer";
import { Toaster } from "@/components/ui/sonner";

function Landing() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.08, smoothWheel: true });
    const raf = (time) => {
      lenis.raf(time);
      requestAnimationFrame(raf);
    };
    requestAnimationFrame(raf);

    const onClick = (e) => {
      const anchor = e.target.closest('a[href^="#"]');
      if (anchor) {
        const target = document.querySelector(anchor.getAttribute("href"));
        if (target) {
          e.preventDefault();
          lenis.scrollTo(target, { offset: -100 });
        }
      }
    };
    document.addEventListener("click", onClick);
    return () => {
      lenis.destroy();
      document.removeEventListener("click", onClick);
    };
  }, []);

  return (
    <>
      <ArrivalGate />
      <ScrollProgress />
      <CustomCursor />
      <Navbar />
      <main>
        <ArrivalJourney />
        <EditorialMarquee />
        <Philosophy />
        <Experience />
        <Services />
        <SignatureRituals />
        <PromoSpotlight />
        <Offers />
        <GiftCertificates />
        <Atmosphere />
        <Therapists />
        <Testimonials />
        <Faq />
        <Booking />
        <Contact />
      </main>
      <Footer />
      <SoundToggle />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <div className="noise-overlay" />
      <LanguageProvider>
        <AmbienceProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/admin" element={<AdminInbox />} />
              <Route path="/menu" element={<PrintMenu />} />
            </Routes>
          </BrowserRouter>
        </AmbienceProvider>
      </LanguageProvider>
      <Toaster position="bottom-right" theme="dark" />
    </div>
  );
}

export default App;
